import React, { Component, Fragment } from "react";
import { Button, Col, Image, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import ImgListView from "../../../../assets/images/icon-list-view.svg";
import ImgLocation from "../../../../assets/images/icon-location-pin.svg";
import ProviderMaps from "../../../../components/UI/ProviderMaps/ProviderMaps";
import Spinner from "../../../../components/UI/Spinner/Spinner";
import { logFirebaseEvent } from "../../../../shared/utility";
import * as findProviderActions from "../../../../store/actions/index";
import ProviderDetails from "../../ProviderDetails/ProviderDetails";
import FindProviderResult from "../../Result/FindProviderResult";
import classes from "./MyFavorites.module.css";

interface IParentProps {
  mapDisplay: boolean;
}
interface IStatefromProps {
  error: boolean;
  loading: boolean;
  errorMessage: string;
  myFavorites: {
    providerId: string;
    providerName: string;
    providerEntityType: string;
    providerLabels: string[];
    longitude: number;
    latitude: number;
    address: string;
    city: string;
    state: string;
    hospitalName: string;
    postalCode: string;
    phoneNumber: string;
    providerType: string;
    specialty: string[];
    isNational:boolean;
    isContracted: true;
    favoriteId: string;
    isFavorite: boolean;
    totalExperienceScore: number;
    distance: number;
    gender: string;
    experienceScore: {
      label: string;
      value: number;
    }[];
    quantrosScores: {
      category: string;
      scores: { name: string; order: number; score: number }[];
    }[];
    providerTypeId: number;
    specialtyId: number;
    medicareValue: number;
    npi: string;
    orgDistance: string;
    orgPostalCode: string;
    finderLabel: string;
    additionalLocationsCount: number;
  }[];
  params: {
    distance: number;
    longitude: string;
    latitude: string;
    postalCode: string;
    providerName: string;
    providerType: string;
    specialty: string;
    scoreHigherThan: number;
    scoreLowerThan: number;
    isContracted: boolean;
    isFavorite: boolean;
    gender: string;
    fetchCurrentLocation: boolean;
    location: string;
    limit: string;
    currentAttempt: number;
    extendedDistance: number;
  };
  unFavoritedProvider: boolean;
  favoritedProvider: boolean;
  favoriteProviderStart: boolean;
  unFavoriteProviderStart: boolean;
  t: any;
}
interface IDispatchFromProps {
  onFetchMyFavorites: (userId: string) => void;
  onFetchProviders: (searchParams: {}) => void;
  onResetUnFavoriteProvider: () => void;
  onResetFavoriteProvider: () => void;
  onResetFetchQualityScoreCategories: () => void;
}
type Props = IStatefromProps & IDispatchFromProps & IParentProps;
class MyFavorites extends Component<Props> {
  state = {
    mapView: false,
    cardView: true,
    searchView: true,
    detailView: false,
    providerIdClicked: "",
    providerTypeId: 0,
    specialtyId: 0,
    npi: "",
    distance: 0,
    postalCode: "",
    orgDistance: "",
    isContracted:false,
    contractStatus: "",
  };

  detailViewHandler = () => {
    console.log("detailViewHandler", "onResetFetchQualityScoreCategories");
    this.props.onResetFetchQualityScoreCategories();
    this.setState({ detailView: false });
    this.setState({ searchView: true });
    console.log(this.state.searchView);
  };
  showMapView = () => {
    this.setState({ mapView: true });
    this.setState({ cardView: false });
    logFirebaseEvent("MapView");
  };
  showCardView = () => {
    this.setState({ mapView: false });
    this.setState({ cardView: true });
  };
  resultViewHandler = (
    providerId: string,
    npi: string,
    distance: number,
    postalCode: string,
    orgDistance: string,
  ) => {
    console.log("resultViewHandler", providerId);
    if (this.props.mapDisplay) {
      this.setState({ providerIdClicked: providerId });
      // this.setState({ providerTypeId: providerTypeId });
      // this.setState({ specialtyId: specialtyId });
      this.setState({ npi: npi });
      this.setState({ distance: distance });
      this.setState({ postalCode: postalCode });
      this.setState({ orgDistance: orgDistance });
      this.setState({ detailView: true });
      this.setState({ searchView: false });
      console.log(this.state.detailView);
    }
  };
  componentDidMount = () => {
    logFirebaseEvent("Favorites");
    console.log(localStorage.getItem("userId"));
    this.props.onFetchMyFavorites(localStorage.getItem("userId")!);
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps.unFavoritedProvider === false &&
        this.props.unFavoritedProvider === true) ||
      (prevProps.favoritedProvider === false &&
        this.props.favoritedProvider === true)
    ) {
      this.props.onFetchProviders(this.props.params);
      this.props.onFetchMyFavorites(localStorage.getItem("userId")!);
      this.props.onResetUnFavoriteProvider();
      this.props.onResetFavoriteProvider();
    }
  }
  render() {
    const { t } = this.props;
    const providersResult =
      this.props.myFavorites &&
      this.props.myFavorites &&
      this.props.myFavorites.length > 0 ? (
        <div className="tabsContentMain">
          {this.state.mapView && (
            <ProviderMaps
              markers={this.props.myFavorites}
              onClick={this.resultViewHandler}
              view="list"
            />
          )}
          {this.state.cardView && (
            <FindProviderResult
              providers={this.props.myFavorites}
              onClick={this.resultViewHandler}
              contractStatus={this.state.contractStatus}
            />
          )}
        </div>
      ) : (
        <div className="tabsContentMain">
          <div className={classes.noResults}>
            {this.props.error && this.props.errorMessage
              ? this.props.errorMessage
              : t("findProviderPage.resultNotFound")}
          </div>
        </div>
      );

    let searchView: any;
    let detailView: any;
    if (this.state.searchView) {
      searchView = (
        <div className="tabContainerMain">
          <Row>
            <Col lg={12}>
              <div className="myFav">
                {this.props.mapDisplay &&
                  this.props.myFavorites &&
                  this.props.myFavorites.length > 0 && (
                    <div className={classes.resLeft}>
                      <h6 className={classes.mdTitle}>
                        {t("findProviderPage.results")} (
                        {this.props.myFavorites.length})
                      </h6>
                    </div>
                  )}
                <div className={classes.resRight}>
                  {this.props.mapDisplay && this.state.cardView && (
                    <Button className="btnLink" onClick={this.showMapView}>
                      {t("findProviderPage.map")}
                      <Image src={ImgLocation} alt="ImgLocation" />
                    </Button>
                  )}
                  {this.state.mapView && (
                    <Button className="btnLink" onClick={this.showCardView}>
                      {t("homePage.listView")}
                      <Image src={ImgListView} alt="ImgListView" />
                    </Button>
                  )}
                </div>
                <div className="clear"></div>
                {providersResult}
              </div>
            </Col>
          </Row>
        </div>
      );
    }
    if (this.state.detailView) {
      detailView = (
        <div className="tabContainerMain">
          <ProviderDetails
            providerId={this.state.providerIdClicked}
            npi={this.state.npi}
            distance={this.state.distance}
            postalCode={this.state.postalCode}
            orgDistance={this.state.orgDistance}
            contractStatus={this.state.contractStatus}
            onClick={this.detailViewHandler}
          />
        </div>
      );
      searchView = null;
    }
    let unFavoriteProviderStartSpinner: any;
    console.log(
      "this.props.favoriteProviderStart",
      this.props.unFavoriteProviderStart
    );
    if (this.props.unFavoriteProviderStart) {
      unFavoriteProviderStartSpinner = <Spinner />;
    }
    return (
      <Fragment>
        {searchView}
        {detailView}
        {unFavoriteProviderStartSpinner}
      </Fragment>
    );
  }
}
const mapStateToProps = (state: any) => ({
  loading: state.myFavorites.loading,
  error: state.myFavorites.error,
  errorMessage: state.providersResult.errorMessage,
  myFavorites: state.myFavorites.myFavorites,
  params: state.searchURL.params,
  unFavoritedProvider: state.favoriteProvider.unFavoritedProvider,
  favoritedProvider: state.favoriteProvider.favoritedProvider,
  unFavoriteProviderStart: state.favoriteProvider.unFavoriteProviderStart,
  favoriteProviderStart: state.favoriteProvider.favoriteProviderStart,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchMyFavorites: (userId) =>
    dispatch(findProviderActions.fetchMyFavorites(userId)),
  onFetchProviders: (searchParams) =>
    dispatch(findProviderActions.fetchProviders(searchParams)),
  onResetUnFavoriteProvider: () =>
    dispatch(findProviderActions.resetUnFavoriteProvider()),
  onResetFavoriteProvider: () =>
    dispatch(findProviderActions.resetFavoriteProvider()),
  onResetFetchQualityScoreCategories: () =>
    dispatch(findProviderActions.resetFetchQualityScoreCategories()),
});
// export default connect(mapStateToProps, mapDispatchToProps)(MyFavorites);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(MyFavorites));
